import { render } from "./RegistOneClass.vue?vue&type=template&id=43d0dee4"
import script from "./RegistOneClass.vue?vue&type=script&lang=js"
export * from "./RegistOneClass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__